import {App} from "vue";

import Toast, {PluginOptions, POSITION} from 'vue-toastification';
import {Capacitor} from "@capacitor/core";

export const applyToast = (app: App) => {
  app.use(Toast, <PluginOptions>{
    position: POSITION.TOP_CENTER,
    rtl: true,
    toastClassName: Capacitor.isNativePlatform()? 'timeit-toast-mac' : 'timeit-toast',
    timeout: 2000,
  });
}
